// @flow
import * as React from 'react';
import type PowerReviewsModerationCard from './PowerReviewsModerationCard';
import KeyboardShortcutsMenu, {
  type ShortcutMenuItem,
} from './KeyboardHelperMenu';

type Props = {
  children?: React.Element<any>,
};

type State = {
  showHelp: boolean,
};

const swallowEvent = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
};

const MENU_ITEMS: ShortcutMenuItem[] = [
  ['p', 'Toggle Product Details'],
  ['m', 'Toggle Meta Info'],
  [['Shift', 's'], 'Second Opinion'],
  [['Shift', 'Enter'], 'Submit'],
];

const elementAcceptsKeyboardInput = (el: ?HTMLElement): boolean => {
  if (!el) {
    return false;
  }

  const tagName = el.tagName;

  if (tagName === 'TEXTAREA') return true;

  if (tagName === 'INPUT') return true;

  return false;
};

export default class KeyboardHelper extends React.PureComponent<Props, State> {
  pwrModerationCard: ?PowerReviewsModerationCard;
  state = {
    showHelp: false,
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeydown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleKeydown = (e: KeyboardEvent) => {
    if (e.defaultPrevented === true || this.state.showHelp === true) {
      return;
    }

    const shouldProcessEvent =
      elementAcceptsKeyboardInput(document.activeElement) === true
        ? false
        : true;

    // we should ignore the second opinion text key presses
    // yes this is a bit hacky
    if (shouldProcessEvent) {
      // p
      if (e.which === 80) {
        swallowEvent(e);
        this.pwrModerationCard && this.pwrModerationCard.toggleSubjectDetails();
      }
      // m
      if (e.which === 77) {
        swallowEvent(e);
        this.pwrModerationCard && this.pwrModerationCard.toggleMeta();
      }
      // shift + s
      if (e.which === 83 && e.shiftKey === true) {
        swallowEvent(e);
        this.pwrModerationCard &&
          this.pwrModerationCard.showSecondOpinionCard();
      }

      // shift + /
      if (e.which === 191 && e.shiftKey === true) {
        swallowEvent(e);
        this.showHelp();
      }
    }

    // shift + enter
    if (e.which === 13 && e.shiftKey === true) {
      swallowEvent(e);
      this.pwrModerationCard && this.pwrModerationCard.handleSubmit();
    }
  };

  showHelp = () => this.setState({ showHelp: true });
  hideHelp = () => this.setState({ showHelp: false });

  render() {
    return (
      <div>
        {this.state.showHelp && (
          <KeyboardShortcutsMenu onClose={this.hideHelp} items={MENU_ITEMS} />
        )}
        {this.props.children &&
          React.cloneElement(this.props.children, {
            ref: c => (this.pwrModerationCard = c),
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/KeyboardHelper.js